RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const presentInvoiceDates = App.models.presentInvoiceDates;

    views.InvoiceDateSelect = Marionette.ItemView.extend({
        ui: {
            invoiceSelect: 'select[name="invoiceSelect"]'
        },

        events: {
            'change select[name="invoiceSelect"]': 'onSelectInvoice'
        },

        template: '#invoiceDateSelectTemplate',

        templateHelpers: function () {
            const me = this;
            const invoiceDates = me.collection.toJSON();
            return {
                invoiceDates: presentInvoiceDates(invoiceDates)
            };
        },

        onBeforeShow: function () {
            const me = this;

            me.ui.invoiceSelect.val(me.model.get('id'));
        },

        onSelectInvoice: function () {
            const invoiceId = this.ui.invoiceSelect.val();
            RivalIQ.execute('history:navigate', `/account/receipts/${invoiceId}`, {
                trigger: true
            });
        }
    });
});
